import { Component, OnInit, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { PromoBannerService } from './promo-banner.service';

@Component({
  selector: 'app-promo-banner',
  templateUrl: './promo-banner.html',
  styleUrls: ['./promo-banner.less'],
  standalone: false
})
export class PromoBanner implements OnInit, AfterViewInit, OnDestroy {

  show = false;
  config: any = null;
  stickyTop = 0;
  private resizeObserver?: ResizeObserver;

  private onCompanyIdChanged = () => this.check_and_load();

  constructor(private banner: PromoBannerService) { }

  ngOnInit() {
    this.check_and_load();
    // company_id a veces se resuelve de forma asincrona despues de que este
    // componente ya se construyo (ej. puente-cliente, SSO por query params).
    // layout.component.ts avisa ese cambio con este evento — nos re-chequeamos.
    window.addEventListener('companyIdChanged', this.onCompanyIdChanged);
  }

  async check_and_load() {
    if (this.banner.is_dismissed()) {
      this.show = false;
      return;
    }

    const company_id = localStorage.getItem('company_id');
    if (!company_id) {
      this.show = false;
      return;
    }

    try {
      const [configRes, eligRes]: any = await Promise.all([
        this.banner.get_config(),
        this.banner.check_eligibility(company_id),
      ]);

      this.config = configRes._body.success;
      this.show = this.config.is_active && eligRes._body.success.eligible;
    } catch {
      this.show = false;
    }
  }

  ngAfterViewInit() {
    this.update_sticky_top();

    const toolbar = document.querySelector('.sticky-toolbar');
    if (toolbar) {
      this.resizeObserver = new ResizeObserver(() => this.update_sticky_top());
      this.resizeObserver.observe(toolbar);
    }
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
    window.removeEventListener('companyIdChanged', this.onCompanyIdChanged);
  }

  @HostListener('window:resize')
  update_sticky_top() {
    const toolbar = document.querySelector('.sticky-toolbar');
    this.stickyTop = toolbar ? toolbar.getBoundingClientRect().height : 0;
  }

  on_download_click() {
    const payload = {
      company_id: localStorage.getItem('company_id'),
      business_name: localStorage.getItem('business_name'),
      rut: localStorage.getItem('rut'),
      user_logged: localStorage.getItem('user_logged'),
      platform: this.banner.is_apple_platform() ? 'ios' : 'android',
      banner_id: this.config?.id,
    };

    this.banner.track_click(payload).catch(() => { });

    window.open(this.banner.get_store_link(), '_blank');
  }

  on_dismiss() {
    this.banner.dismiss();
    this.show = false;
  }
}
